<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            客流统计
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                    <!-- <el-button type="primary" plain @click.native="toggleModalAdd">添加</el-button> -->
                    <div style="float:right">
                        <el-input  placeholder="请输入姓名" v-model="name" clearable style="margin:0 5px;width:200px"></el-input>
                        <el-date-picker
                            ref="picker"
                            v-model="datetimerangeValue"
                            type="daterange"
                            :clearable='false'
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width:250px;margin:0 5px;">
                        </el-date-picker>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" border style="width: 100%;">


                        <el-table-column prop="name" label="姓名"></el-table-column>
                        <el-table-column prop="idNumber" label="身份证号"></el-table-column>
                        <el-table-column prop="temperature" label="温度"></el-table-column>
                        <el-table-column prop="nameTag" label="设备所属机构别名"></el-table-column>
                        <!-- <el-table-column fixed="right" label="操作" width="200">
                            <template slot-scope="scope">
                                <el-button type="primary" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                            </template>
                        </el-table-column> -->

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <!-- <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit> -->

    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    // import Edit from "./Edit";
    // import Add from "./Add";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                name:'',
                showModalAdd:false,
                showModalEdit:false,
                searchDishes:'',
                datetimerangeValue:'',
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                status:-1,
                statusValue:[{name:'全部状态',value:-1},{name:'正常',value:0},{name:'禁用',value:1}]

            }
        },
        // components:{
        //     Add,Edit
        // },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            init(){
                const end= new Date();
                const start=new Date(end.getTime() - 1000 * 60 * 60 * 24 * 30);
                this.datetimerangeValue=[start, end];
            },
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },
            getList(){

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"PassengerFlow/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        name:this.name,
                        startTime:timefilters(this.datetimerangeValue[0]).slice(0,10),
                        endTime:timefilters(this.datetimerangeValue[1]).slice(0,10),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },



        }
    }
</script>

<style scoped>

</style>
